import { render, staticRenderFns } from "./PersonalAdvisor.vue?vue&type=template&id=6c32ed87&scoped=true"
import script from "./PersonalAdvisor.vue?vue&type=script&lang=js"
export * from "./PersonalAdvisor.vue?vue&type=script&lang=js"
import style0 from "./PersonalAdvisor.vue?vue&type=style&index=0&id=6c32ed87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32ed87",
  null
  
)

export default component.exports